/* Aurate New York Theme — theme.js */
'use strict';

document.addEventListener('DOMContentLoaded', () => {

  /* ── Refs ───────────────────────────────────────────────── */
  const overlay    = document.getElementById('au-overlay');
  const mobileNav  = document.getElementById('au-mobile-nav');
  const cartDrawer = document.getElementById('au-cart-drawer');

  /* ── Panel helpers ──────────────────────────────────────── */
  function openPanel(el) {
    if (!el) return;
    // Close everything first
    [mobileNav, cartDrawer].forEach(p => {
      if (!p) return;
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    // Open target
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    // Only show overlay for cart drawer, not mobile nav
    if (overlay && el === cartDrawer) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll(restoreScroll = true) {
    [mobileNav, cartDrawer].forEach(p => {
      if (!p) return;
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    if (restoreScroll) document.body.style.overflow = '';
  }

  document.getElementById('au-menu-open')?.addEventListener('click', () => openPanel(mobileNav));
  document.getElementById('au-menu-close')?.addEventListener('click', closeAll);
  document.getElementById('au-cart-open')?.addEventListener('click', () => openPanel(cartDrawer));
  document.getElementById('au-cart-close')?.addEventListener('click', closeAll);
  overlay?.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  /* ── Cart helpers ───────────────────────────────────────── */
  function setCartCount(n) {
    const b = document.getElementById('au-cart-count');
    if (!b) return;
    b.textContent = n;
    b.classList.toggle('is-hidden', n === 0);
  }

  /* ── Quick Add ──────────────────────────────────────────── */
  window.auQuickAdd = function(variantId, btn, event) {
    if (event) event.preventDefault();
    if (!variantId) return;
    const orig = btn.textContent;
    btn.textContent = 'ADDING…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = 'ADDED ✓';
      fetch('/cart.js').then(r => r.json()).then(cart => {
        setCartCount(cart.item_count);
        refreshCart();
        openPanel(cartDrawer);
      });
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(() => { btn.textContent = 'ERROR'; btn.disabled = false; });
  };

  /* ── Refresh cart drawer ────────────────────────────────── */
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const body = document.getElementById('au-cart-body');
        const sub  = document.getElementById('au-cart-subtotal');
        if (sub) sub.textContent = formatMoney(cart.total_price);
        if (body) {
          if (cart.items.length === 0) {
            body.innerHTML = '<p style="text-align:center;padding:3rem;color:#888;font-size:.82rem;letter-spacing:.06em;">Your bag is empty.</p><a href="/collections/all" class="au-btn au-btn--solid" style="margin:0 1.5rem;">SHOP ALL</a>';
          } else {
            body.innerHTML = cart.items.map(item => `
              <div class="au-cart-item" data-key="${item.key}">
                <a href="${item.url}" class="au-cart-item__img">
                  <img src="${item.image}" alt="${item.title}" width="80" height="80" style="object-fit:cover;width:80px;height:80px;">
                </a>
                <div class="au-cart-item__info">
                  <p class="au-cart-item__title">${item.product_title}</p>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="au-cart-item__variant">${item.variant_title}</p>` : ''}
                  <p class="au-cart-item__price">${formatMoney(item.final_price)}</p>
                  <div class="au-cart-item__actions">
                    <div class="au-qty">
                      <button class="au-qty__btn" data-key="${item.key}" data-action="minus">−</button>
                      <span class="au-qty__val">${item.quantity}</span>
                      <button class="au-qty__btn" data-key="${item.key}" data-action="plus">+</button>
                    </div>
                    <button class="au-cart-item__remove" data-key="${item.key}">Remove</button>
                  </div>
                </div>
              </div>
            `).join('');
          }
        }
        bindCartEvents();
      }).catch(() => {});
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Cart qty / remove ──────────────────────────────────── */
  function bindCartEvents() {
    document.querySelectorAll('.au-qty__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key  = btn.dataset.key;
        const item = btn.closest('.au-cart-item');
        const qEl  = item?.querySelector('.au-qty__val');
        let qty = parseInt(qEl?.textContent || 1);
        qty = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        changeItem(key, qty);
      });
    });
    document.querySelectorAll('.au-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => changeItem(btn.dataset.key, 0));
    });
  }

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => { setCartCount(cart.item_count); refreshCart(); });
  }

  bindCartEvents();

  /* ── Tabs (Good Gold section) ───────────────────────────── */
  document.querySelectorAll('.au-tabs').forEach(tabGroup => {
    const tabs   = tabGroup.querySelectorAll('.au-tab');
    const panels = tabGroup.closest('.au-tabbed')?.querySelectorAll('.au-tab-panel');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('is-active'));
        panels?.forEach(p => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        if (panels && panels[i]) panels[i].classList.add('is-active');
      });
    });
    // activate first
    if (tabs[0]) tabs[0].classList.add('is-active');
    if (panels && panels[0]) panels[0].classList.add('is-active');
  });

  /* ── Product gallery ────────────────────────────────────── */
  const mainImg = document.getElementById('au-pdp-main');
  document.querySelectorAll('.au-pdp__thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.au-pdp__thumb').forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (mainImg) mainImg.src = t.dataset.src;
    });
  });

  /* ── PDP variant selector ───────────────────────────────── */
  document.querySelectorAll('.au-vbtn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.au-pdp__variants');
      group?.querySelectorAll('.au-vbtn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const form = btn.closest('form');
      const inp  = form?.querySelector('[name="id"]');
      if (inp && btn.dataset.variantId) inp.value = btn.dataset.variantId;
    });
  });

  /* ── PDP AJAX add ───────────────────────────────────────── */
  const pdpForm = document.getElementById('au-pdp-form');
  const addBtn  = document.getElementById('au-pdp-add');
  if (pdpForm && addBtn) {
    pdpForm.addEventListener('submit', e => {
      e.preventDefault();
      const id = pdpForm.querySelector('[name="id"]')?.value;
      if (!id) return;
      addBtn.textContent = 'ADDING…';
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        addBtn.textContent = 'ADDED TO BAG ✓';
        fetch('/cart.js').then(r => r.json()).then(cart => {
          setCartCount(cart.item_count);
          refreshCart();
          openPanel(cartDrawer);
        });
        setTimeout(() => { addBtn.textContent = 'ADD TO BAG'; addBtn.disabled = false; }, 2500);
      })
      .catch(() => { addBtn.textContent = 'PLEASE TRY AGAIN'; addBtn.disabled = false; });
    });
  }

  /* ── Collection filters ─────────────────────────────────── */
  document.querySelectorAll('.au-filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.au-filter-pill').forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      const tag = pill.dataset.tag;
      document.querySelectorAll('.au-card').forEach(card => {
        if (!tag || tag === 'all') { card.style.display = ''; return; }
        const cardTags = (card.dataset.tags || '').toLowerCase().replace(/-/g, ' ');
        const filterTag = tag.toLowerCase().replace(/-/g, ' ');
        card.style.display = cardTags.includes(filterTag) ? '' : 'none';
      });
    });
  });

  /* ── Sort ───────────────────────────────────────────────── */
  document.getElementById('au-sort')?.addEventListener('change', function() {
    const val  = this.value;
    const grid = document.querySelector('.au-grid');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('.au-card')];
    cards.sort((a, b) => {
      const pa = parseFloat(a.querySelector('.au-card__price')?.textContent.replace(/[^0-9.]/g, '') || 0);
      const pb = parseFloat(b.querySelector('.au-card__price')?.textContent.replace(/[^0-9.]/g, '') || 0);
      return val === 'price-asc' ? pa - pb : val === 'price-desc' ? pb - pa : 0;
    });
    cards.forEach(c => grid.appendChild(c));
  });

});
